<div class="mg-modal-version" *ngIf="translate && translate!.version">
  <div class="mg-modal-version__header">
    <span class="mg-modal-version__header__title">
      {{ translate.title }}
    </span>
    <mat-icon
      class="mg-modal-version__header__close"
      (click)="dialogRef.close()"
      >close</mat-icon
    >
  </div>
  <div class="mg-modal-version__content">
    <span class="mg-modal-version__content__module"
      >{{ translate.module }} {{ translate.nameModule }}</span
    >
    <div class="mg-modal-version__content__info">
      <p class="mg-modal-version__content__info__detail">
        <b>{{ translate.version }}:</b> {{ version.version }}
      </p>
      <p class="mg-modal-version__content__info__detail">
        <b>{{ translate.date }}:</b> {{ version.date | date }}
      </p>
      <p class="mg-modal-version__content__info__detail">
        <b>{{ translate.notes }}</b>
      </p>
      <p class="mg-modal-version__content__info__detail-feature">
        <b>{{ translate.features }}</b>
        <span *ngFor="let feature of version.features"> {{ feature }} </span>
      </p>
      <p class="mg-modal-version__content__info__detail-feature">
        <b>{{ translate.improviments }}</b>
        <span *ngFor="let improvement of version.improvements">
          {{ improvement }}
        </span>
      </p>
    </div>
  </div>
</div>
